import type { PermissionAreaCode } from '@/shared/i18n/locales/en-US/common';
import type { PermissionCatalogue } from '@/modules/roles/api';

/** A flat `code → area` lookup folded from the area-first `GET /api/v1/franchise-administration/permissions` catalogue. */
export function permissionAreaIndex(
  catalogue: PermissionCatalogue | undefined,
): Map<string, PermissionAreaCode> {
  const index = new Map<string, PermissionAreaCode>();
  catalogue?.areas.forEach((area) =>
    area.modules.forEach((module) =>
      module.actions.forEach((action) =>
        action.permissions.forEach((permission) =>
          index.set(permission.code, area.area as PermissionAreaCode),
        ),
      ),
    ),
  );
  return index;
}

/**
 * The subset of a Role's `permissions` that currently take effect from a RoleAssignment.
 * Franchise-administration permissions always apply from the assignment. Venue-workspace
 * permissions apply only when the assignment has selected or implicit VenueAccess.
 */
export function effectivePermissions(
  rolePermissions: readonly string[],
  hasVenueAccess: boolean,
  areaIndex: Map<string, PermissionAreaCode>,
): string[] {
  return rolePermissions.filter((code) => {
    const area = areaIndex.get(code);
    return area === 'franchise_administration' || (hasVenueAccess && area === 'venue_workspace');
  });
}
